export default __webpack_public_path__ + "static/media/deloitte-special-use-icon-font.b2b83873.otf";